import { Provider } from '@angular/core';

import { WEB_APP_API_BASE_URL } from '@rent2end/core/auth';

export { WEB_APP_API_BASE_URL };

export const provideWebAppApiBaseUrl = (baseUrl: string): Provider => ({
  provide: WEB_APP_API_BASE_URL,
  useValue: baseUrl,
});
